import { render } from "./issue-section.vue?vue&type=template&id=01e9145e&ts=true"
import script from "./issue-section.vue?vue&type=script&lang=ts"
export * from "./issue-section.vue?vue&type=script&lang=ts"

import "./issue-section.vue?vue&type=style&index=0&id=01e9145e&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__